import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaEnvelope, FaSave, FaTrash, FaUser, FaPhone, FaMapMarkerAlt, FaBolt, FaCalendarAlt } from 'react-icons/fa';
import styles from './Admin.module.css';

const AdminContact = () => {
  const [leads, setLeads] = useState([]);
  const [adminEmail, setAdminEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const API_URL = "http://localhost:5042/api/Contact";

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      // 1. Fetch Leads
     const leadsRes = await api.get('/Contact/leads', { headers });
      setLeads(leadsRes.data);

      // 2. Fetch Current Admin Email
    const emailRes = await api.get('/Contact/get-admin-email', { headers });
      setAdminEmail(emailRes.data.email);

    } catch (err) {
      console.error("Error fetching data", err);
    }
  };

  // --- DELETE LEAD ---
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this inquiry?")) return;
    
    try {
      const token = localStorage.getItem('token');
    await api.delete(`/Contact/delete-lead/${id}`, {
  headers: { Authorization: `Bearer ${token}` }
});
      // Remove from UI directly for speed
      setLeads(leads.filter(lead => lead.id !== id));
      setMessage({ text: "Lead deleted successfully", type: "success" });
      
      // Clear message after 3 sec
      setTimeout(() => setMessage({ text: '', type: '' }), 3000);

    } catch (err) {
      alert("Error deleting lead");
    }
  };
// --- UPDATE RECEIVER EMAIL ---
  const handleEmailUpdate = async (e) => {
    e.preventDefault();
    setEmailLoading(true);
    
    // Debugging ke liye
    console.log("Sending Email Update:", adminEmail);

    try {
      const token = localStorage.getItem('token');
      
      // 👇 CHANGE HERE: "KeyName" bhi bhejein, taaki backend confuse na ho
      const payload = { 
        KeyName: "AdminEmail", 
        Value: adminEmail 
      };

     await api.post('/Contact/update-admin-email', payload, {
  headers: { Authorization: `Bearer ${token}` }
});

      setMessage({ text: "Receiver Email Updated Successfully! Future leads will go here.", type: "success" });
    
    } catch (err) {
      console.error("Update Error:", err.response ? err.response.data : err); // Error console me dekhein
      setMessage({ text: "Failed to update email. Check Console for details.", type: "error" });
    } finally {
      setEmailLoading(false);
    }
  };

  return (
    <div className={styles.adminTheme} style={{ display: 'block', height: 'auto', paddingBottom: '50px' }}>
      
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h2 style={{ marginBottom: '1.5rem', color: '#fff', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaUser /> Lead Management
        </h2>

        {/* --- SECTION 1: NOTIFICATION SETTINGS --- */}
        <div className={styles.formCard} style={{ marginBottom: '30px', borderLeft: '4px solid #4ade80' }}>
          <h4 style={{ color: '#4ade80', marginBottom: '15px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <FaEnvelope /> Notification Settings
          </h4>
          <p style={{ color: '#94a3b8', fontSize: '0.9rem', marginBottom: '15px' }}>
            This email address receives all "Contact Us" form submissions.
          </p>
          
          <form onSubmit={handleEmailUpdate} style={{ display: 'flex', gap: '10px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: '250px' }}>
              <label style={{ color: '#fff', fontSize: '0.9rem', marginBottom: '5px', display: 'block' }}>Receiver Email Address</label>
              <input 
                type="email" 
                className={styles.formInput} 
                value={adminEmail} 
                onChange={(e) => setAdminEmail(e.target.value)} 
                placeholder="e.g. admin@rengie.in"
                required
              />
            </div>
            <button className={styles.primaryBtn} style={{ width: 'auto', height: '46px' }} disabled={emailLoading}>
              {emailLoading ? 'Saving...' : <><FaSave /> Update Email</>}
            </button>
          </form>
          
          {message.text && (
            <div style={{ marginTop: '15px', padding: '10px', borderRadius: '5px', background: message.type === 'success' ? 'rgba(74, 222, 128, 0.2)' : 'rgba(239, 68, 68, 0.2)', color: message.type === 'success' ? '#4ade80' : '#ef4444' }}>
              {message.text}
            </div>
          )}
        </div>

        {/* --- SECTION 2: LEADS LIST --- */}
        <div>
          <h4 style={{ color: '#fff', marginBottom: '15px' }}>Inquiries Received ({leads.length})</h4>
          
          {leads.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', background: 'rgba(255,255,255,0.05)', borderRadius: '10px', color: '#94a3b8' }}>
              No inquiries found yet.
            </div>
          ) : (
            <div style={{ display: 'grid', gap: '15px' }}>
              {leads.map((lead) => (
                <div key={lead.id} style={{ background: 'rgba(255, 255, 255, 0.05)', padding: '20px', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.1)', position: 'relative' }}>
                  
                  {/* Header Row: Name & Date */}
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '15px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '10px' }}>
                    <div>
                      <h5 style={{ margin: 0, color: '#4ade80', fontSize: '1.2rem' }}>{lead.name}</h5>
                      <span style={{ fontSize: '0.85rem', color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '5px', marginTop: '5px' }}>
                        <FaCalendarAlt /> {new Date(lead.submittedAt).toLocaleString()}
                      </span>
                    </div>
                    <button 
                      onClick={() => handleDelete(lead.id)}
                      style={{ background: 'rgba(239, 68, 68, 0.2)', border: 'none', color: '#ef4444', padding: '8px 12px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}
                    >
                      <FaTrash /> Delete
                    </button>
                  </div>

                  {/* Details Grid */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '15px' }}>
                    <div>
                      <small style={{ color: '#64748b', display: 'block' }}>Contact Info</small>
                      <div style={{ color: '#e2e8f0', display: 'flex', alignItems: 'center', gap: '8px', marginTop: '5px' }}><FaPhone size={12}/> {lead.phone}</div>
                      <div style={{ color: '#e2e8f0', display: 'flex', alignItems: 'center', gap: '8px', marginTop: '5px' }}><FaEnvelope size={12}/> {lead.email || 'N/A'}</div>
                    </div>
                    <div>
                      <small style={{ color: '#64748b', display: 'block' }}>Site Details</small>
                      <div style={{ color: '#e2e8f0', display: 'flex', alignItems: 'center', gap: '8px', marginTop: '5px' }}><FaMapMarkerAlt size={12}/> {lead.location}</div>
                      <div style={{ color: '#e2e8f0', display: 'flex', alignItems: 'center', gap: '8px', marginTop: '5px' }}><FaBolt size={12}/> Bill: ₹{lead.electricityBill} | Roof: {lead.roofArea} sqft</div>
                    </div>
                  </div>

                  {/* Message Box */}
                  <div style={{ background: 'rgba(0,0,0,0.2)', padding: '15px', borderRadius: '8px' }}>
                    <small style={{ color: '#64748b', display: 'block', marginBottom: '5px' }}>Message / Requirements:</small>
                    <p style={{ margin: 0, color: '#f1f5f9', lineHeight: '1.5' }}>
                      {lead.message || "No additional message provided."}
                    </p>
                  </div>

                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminContact;